import { Environment, environments } from '@web/config';

export const environment: Environment = {
  ...environments.development,
};
